import React, {useEffect, useState} from 'react';
import Swiper from "../Components/Swiper";
import {Collapse, CardBody, Card} from 'reactstrap';
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import axios from "../Config/axios";

function Info() {
    const [data, setData] = useState([]);
    const [isMobile, setIsMobile] = useState(false);
    const [openCollapseIndex, setOpenCollapseIndex] = useState(null);


    const toggle = (index) => {
        setOpenCollapseIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    useEffect(() => {
        axios
            .get("info/get")
            .then((res) => {
                let {code} = res.data;

                if (code === 200) {
                    setData(res?.data?.data?.info);
                } else if (code === 400) {
                    setData(res?.data?.data?.info);
                }
            })
            .catch(() => {
            });
    }, []);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.outerWidth <= 768); // Adjust the breakpoint according to your needs
        };

        handleResize(); // Check initial width
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (
        <div className={`background ${isMobile ? 'header-placement' : ''}`}>
            {!isMobile && <Swiper/>}
            <Navbar activeLink='info'/>
            <div className='wrapper'>

                <div className='home-title'>100 сая ₮-ийн аяны тухай</div>
                {data.map((el, i) => (
                    <div key={i} className="collapse-wrapper">
                        <Card
                            key={i}
                            onClick={() => toggle(i)}
                            style={{ marginBottom: '5px' }}
                            className="collapse-button"
                        >
                            <CardBody>{el.title}</CardBody>
                        </Card>
                        <Collapse isOpen={openCollapseIndex === i} className="collapse-body">
                            <div dangerouslySetInnerHTML={{ __html: el.content }} />
                        </Collapse>
                    </div>
                ))}
                <Footer isMobile={isMobile}/>
            </div>
        </div>
    );
}

export default Info;